import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number | string | null | undefined, currency: string = "USD"): string {
  if (amount === null || amount === undefined || amount === '') {
    return `${currency === 'USD' ? '$' : ''}0.00`
  }
  
  try {
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount
    
    if (isNaN(numAmount)) {
      return `${currency === 'USD' ? '$' : ''}0.00`
    }
    
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
    }).format(numAmount)
  } catch (error) {
    console.error('Error formatting currency:', error, 'Input:', amount, 'Currency:', currency)
    return `${currency === 'USD' ? '$' : ''}0.00`
  }
}

export function formatDate(date: Date | string | null | undefined): string {
  if (!date) return 'N/A'
  
  try {
    const dateObj = date instanceof Date ? date : new Date(date)
    
    // Check if the date is valid
    if (isNaN(dateObj.getTime())) {
      return 'Invalid Date'
    }
    
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(dateObj)
  } catch (error) {
    console.error('Error formatting date:', error, 'Input:', date)
    return 'Invalid Date'
  }
}

export function generateApiKey(): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = 'sk_'
  for (let i = 0; i < 32; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

export function generateMerchantId(): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let result = 'M_'
  for (let i = 0; i < 8; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

export function copyToClipboard(text: string): Promise<void> {
  return navigator.clipboard.writeText(text)
} 